import { render, staticRenderFns } from "./ProfileAddressesEdit.vue?vue&type=template&id=82c868f8&scoped=true"
import script from "./ProfileAddressesEdit.vue?vue&type=script&lang=js"
export * from "./ProfileAddressesEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82c868f8",
  null
  
)

export default component.exports